// extracted by mini-css-extract-plugin
module.exports = {"additionalMessage":"AdditionalMessage_additionalMessage__jcOZk"};